import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
var DigitCase = /** @class */ (function (_super) {
    __extends(DigitCase, _super);
    function DigitCase() {
        return _super.call(this) || this;
    }
    DigitCase.forceNativeConstructor = true;
    DigitCase.forceNativeMethods = true;
    // JS -> AS Bindings
    DigitCase.DEFAULT = 'default';
    DigitCase.LINING = 'lining';
    DigitCase.OLD_STYLE = 'oldStyle';
    return DigitCase;
}(ASObject));
export { DigitCase };
